module.exports = __webpack_public_path__ + "static/media/timber04.bc261ad0.png";